/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-widgets/DatePicker';
import TimePickerHour from 'app/components/common/TimePickerHour.jsx';
import TimePickerMeridiem from 'app/components/common/TimePickerMeridiem.jsx';
import TimePickerMinute from 'app/components/common/TimePickerMinute.jsx';
import * as _ from 'underscore';


const postActions = {
  now: 'now',
  next: 'next',
  showSchedule: 'showSchedule',
  schedule: 'schedule',
  queue: 'queue',
  everqueue: 'everqueue'
};

class PostModalScheduleOverlay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: true,
            scheduleTime: null
        };

        this.setHours = this.setHours.bind(this);
        this.setMinutes = this.setMinutes.bind(this);
        this.setMeridiem = this.setMeridiem.bind(this);
        this.setScheduleDate = this.setScheduleDate.bind(this);
        this.scheduleHandler = this.scheduleHandler.bind(this);
        this.hideOverlay = this.hideOverlay.bind(this);
        this.formatter = this.formatter.bind(this);

    }

    componentDidMount() {

        let scheduleTime = this.props.initialScheduleTime;

        if (scheduleTime === null && this.props.user.detail.timezone) {
            scheduleTime = moment().tz(this.props.user.detail.timezone);
        } else if (this.props.user.detail.timezone) {
            scheduleTime = moment(scheduleTime).tz(this.props.user.detail.timezone);
        }

        this.setState({
            scheduleTime: scheduleTime
        });

    }

    setHours(hour) {

        let scheduleTime = moment(this.state.scheduleTime).tz(this.props.user.detail.timezone);

        scheduleTime.hour(hour);

        this.setState({scheduleTime: scheduleTime});

    }

    setMinutes(minute) {

        let scheduleTime = moment(this.state.scheduleTime).tz(this.props.user.detail.timezone);

        scheduleTime.minute(minute);

        this.setState({scheduleTime: scheduleTime});

    }

    setMeridiem(meridiem) {

        let scheduleTime = moment(this.state.scheduleTime).tz(this.props.user.detail.timezone),
            scheduleHour,
            scheduleMeridiem;

        scheduleHour = scheduleTime.hour();
        scheduleMeridiem = scheduleTime.format('A');

        if (meridiem === 'PM' && scheduleMeridiem === 'AM') {
            scheduleHour = scheduleHour + 12;
        } else if (meridiem === 'AM' && scheduleMeridiem === 'PM') {
            scheduleHour = scheduleHour - 12;
        }

        scheduleTime.hour(scheduleHour);

        this.setState({scheduleTime: scheduleTime});

    }

    setScheduleDate(val) {

        let date = new Date(val),
            scheduleDate = moment(this.state.scheduleTime).tz(this.props.user.detail.timezone);

        scheduleDate.year(date.getFullYear());
        scheduleDate.month(date.getMonth());
        scheduleDate.date(date.getDate());

        this.setState({scheduleTime: scheduleDate});

    }

    scheduleHandler() {

        this.props.scheduleHandler(this.state.scheduleTime.toISOString());

    }

    hideOverlay() {

        if (_.isFunction(this.props.hideOverlay)) {
            this.props.hideOverlay();
        } else {
            this.setState({visible: false});
        }

    }

    formatter(date) {
        return (date) ? moment.tz(date, this.props.user.detail.timezone).format("MMM DD YYYY") : '';
    }

    render() {

        let ret = null,
            timezone = this.props.user.detail.timezone,
            scheduleTime = this.state.scheduleTime;

        if (this.state.visible) {
            ret = (
                <div className="post-schedule-container">
                    <div className="item-schedule overlay item-row-overlay post-post-schedule">
                        <div className="schedule-picker">
                            <DatePicker
                                value={new Date(this.state.scheduleTime)}
                                onChange={this.setScheduleDate}
                                className="queue-picker"/>
                        </div>
                        <div className="item-list-control curate-item-list-control item-list-sort curate-item-list-sort">
                            <TimePickerHour
                                {...this.props}
                                offset={false}
                                scheduleTime={this.state.scheduleTime}
                                changeHandler={this.setHours}/>
                        </div>
                        <div className="item-list-control curate-item-list-control item-list-sort curate-item-list-sort">
                            <TimePickerMinute
                                {...this.props}
                                offset={false}
                                scheduleTime={this.state.scheduleTime}
                                changeHandler={this.setMinutes}/>
                        </div>
                        <div className="item-list-control curate-item-list-control item-list-sort curate-item-list-sort">
                            <TimePickerMeridiem
                                {...this.props}
                                offset={false}
                                scheduleTime={this.state.scheduleTime}
                                changeHandler={this.setMeridiem}/>
                        </div>
                        <div className="btn-item-schedule form-button" onClick={this.scheduleHandler} role="button" aria-label="schedule">Schedule</div>
                        <div className="item-close" onClick={this.hideOverlay} role="button" aria-label="close scheduler">
                            <i className="fa fa-times-circle-o"></i>
                        </div>
                    </div>
                </div>
            );
        }

        return ret;

    }

};

PostModalScheduleOverlay.displayName = "PostModalScheduleOverlay";

PostModalScheduleOverlay.propTypes = {
    hideOverlay: PropTypes.func,
    initialScheduleTime: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    scheduleHandler: PropTypes.func.isRequired,
};

PostModalScheduleOverlay.defaultProps = {
    hideOverlay: null,
    initialScheduleTime: null,
    scheduleHandler: null,
};

export default PostModalScheduleOverlay;
